class CartDrawer extends HTMLElement {
	constructor() {
		super();

		this.setHeaderCartIconAccessibility();

		const queryString = window.location.search;
		const urlParams = new URLSearchParams(queryString);
		const product = urlParams.get('cart');

		if (product == 'true') {
			this.open();
		}

		this.btnsValidNote = document.querySelectorAll('[data-note-btn]');
		this.btnDeleteNote = document.querySelector('[data-note-btn-delete]');
		this.textAreaNote = document.querySelector('[data-note-textarea]');
		this.noteFakeField = document.querySelector('[data-note-fake-field]');
		this.noteCountLabel = document.querySelector('[data-note-count]');
		
		if (this.textAreaNote) {
			const elTextLength = this.textAreaNote.value.length;

			if (elTextLength > 0) {		
				document.querySelector('[data-note-display]').checked = true;
				document.querySelector('[data-note-content]').classList.remove('u-hidden');
			}

			this.noteCountLabel.innerHTML = this.textAreaNote.value.length;
			this.textAreaNote.addEventListener('input', (e) => {	
				const textLength = this.textAreaNote.value.length;
				this.noteCountLabel.innerHTML = textLength;

				if (textLength > 0) {
					this.btnsValidNote[0].classList.remove('is-disable');
					this.btnsValidNote[0].removeAttribute('aria-disabled');
				} else {
					this.btnsValidNote[0].classList.add('is-disable');
					this.btnsValidNote[0].setAttribute('aria-disabled', 'true');
				}

				let text = e.target.value;

				// Ensure only the first letter of each word can be uppercase, and the rest are lowercase and remove emoji
				text = text.replace(/\b([a-zA-Z])([a-zA-Z]*)\b|\p{Emoji}/gu, function (match, p1, p2) {
					if (p1 && p2 !== undefined) { // apply only if not emoji
						// p1 is the first letter (any case allowed), p2 is the rest of the word (forced to lowercase)
						return p1 + p2.toLowerCase();
					}
					return ""; // remove emojis
				});
				e.target.value = text;
			});
		}

		this.btnsValidNote.forEach((btn) => {
			btn.addEventListener('click', this.toggleNote.bind(this));
		});

		if (this.btnDeleteNote) {
			this.btnDeleteNote.addEventListener('click', this.deleteNote.bind(this));
		}
	}

	toggleNote() {
		this.noteFakeField.innerHTML = this.textAreaNote.value;
		this.btnDeleteNote.classList.toggle('u-hidden');
		this.textAreaNote.classList.toggle('u-hidden');
		this.noteFakeField.classList.toggle('u-hidden');

		this.btnsValidNote.forEach((btn) => {
			btn.classList.toggle('!u-hidden');
		});
	}

	deleteNote() {
		document.querySelector('[data-note-display]').checked = false;
		document.querySelector('[data-note-content]').classList.add('u-hidden');
		this.textAreaNote.value = this.noteFakeField.innerHTML = '';
		this.noteCountLabel.innerHTML = '0';
		// Push an empty cart note
		const body = JSON.stringify({note: ''});
		fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{body}});
	}

	setHeaderCartIconAccessibility() {
		const cartLink = document.querySelectorAll('cart__bubble');
		cartLink.forEach((el) => {
			el.setAttribute('role', 'button');
			el.setAttribute('aria-haspopup', 'dialog');
			el.addEventListener('click', (event) => {
				event.preventDefault();
				this.open(el);
			});
			el.addEventListener('keydown', (event) => {
				if (event.code.toUpperCase() === 'SPACE') {
					event.preventDefault();
					this.open(el);
				}
			});
		});
	}

	open(triggeredBy) {
		if (triggeredBy) this.setActiveElement(triggeredBy);
		const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
		if (cartDrawerNote && !cartDrawerNote.hasAttribute('role'))
			this.setSummaryAccessibility(cartDrawerNote);
		// here the animation doesn't seem to always get triggered. A timeout seem to help
		setTimeout(() => {
			this.classList.add('animate', 'is-visible');
			document.querySelector('#cart').classList.add('is-visible');
		});
	}

	close() {
		this.classList.remove('is-visible');
		removeTrapFocus(this.activeElement);
	}

	setSummaryAccessibility(cartDrawerNote) {
		cartDrawerNote.setAttribute('role', 'button');
		cartDrawerNote.setAttribute('aria-expanded', 'false');

		if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
			cartDrawerNote.setAttribute(
				'aria-controls',
				cartDrawerNote.nextElementSibling.id,
			);
		}

		cartDrawerNote.addEventListener('click', (event) => {
			event.currentTarget.setAttribute(
				'aria-expanded',
				!event.currentTarget.closest('details').hasAttribute('open'),
			);
		});

		cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
	}

	renderContents(parsedState) {
		this.cartItemKey = parsedState.key;
		this.productId = parsedState.id;
		this.getSectionsToRender().forEach((section) => {
			const sectionElement = section.selector
				? document.querySelector(section.selector)
				: document.getElementById(section.id);
			if (sectionElement) {
				sectionElement.innerHTML = this.getSectionInnerHTML(
					parsedState.sections[section.id],
					section.selector,
				);
			}
		});
	}

	getSectionInnerHTML(html, selector = '.shopify-section') {
		return new DOMParser()
			.parseFromString(html, 'text/html')
			.querySelector(selector).innerHTML;
	}

	getSectionsToRender() {
		return [
			{
				id: 'header',
				section: 'cart-icon-bubble',
				selector: '#cart-icon-bubble',
			},
			{
				id: 'cart-drawer',
				selector: '.c-sidebar__title',
			},
			{
				id: 'cart-drawer',
				selector: '.drawer__count',
			},
			{
				id: 'cart-icon-bubble',
				selector: '.bubble__count',
			},
			{
				id: 'cart-drawer',
				selector: '#CartDrawer-CartItems',
			},
			{
				id: 'cart-drawer',
				selector: '.drawer__content',
			},
			{
				id: 'cart-drawer',
				selector: '.c-sidebar__title',
			},
			{
				id: 'cart-drawer',
				selector: '#CartDrawer-Checkout',
			}
		];
	}

	getSectionDOM(html, selector = '.shopify-section') {
		return new DOMParser()
			.parseFromString(html, 'text/html')
			.querySelector(selector);
	}

	setActiveElement(element) {
		this.activeElement = element;
	}
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
	getSectionsToRender() {
		return [
			{
				id: 'CartDrawer',
				section: 'cart-drawer',
				selector: '.drawer__content',
			},
			{
				id: 'CartDrawer',
				section: 'cart-drawer',
				selector: '#CartDrawer-Checkout',
			},
			{
				id: 'cart-drawer',
				section: 'cart-drawer',
				selector: '.drawer__count',
			},
			{
				id: 'header',
				section: 'cart-icon-bubble',
				selector: '#cart-icon-bubble',
			},
			{
				id: 'cart-drawer',
				section: 'cart-drawer',
				selector: '.c-sidebar__title',
			},
			{
				id: 'cart-drawer',
				selector: '.bubble__count',
			}
		];
	}
}

customElements.define('cart-drawer-items', CartDrawerItems);
